var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"89483e39899c62e9fdfcd9fcbfcfd1716505f7b0"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["yogobe-web@yogobe"]={id:"89483e39899c62e9fdfcd9fcbfcfd1716505f7b0"};
      